import { Button } from '@/components/ui/shadcn/button'
import { CassiSquareIcon } from '@/components/ui/icons/CassiSquareIcon'
import { MagicIcon } from '@/components/ui/icons/icons-new'

interface Props {
  onSendMessage: (message: string) => Promise<void>
}

export function WorkspaceChatInitial({ onSendMessage }: Props) {
  const suggestions = [
    { text: 'Rate my caption', message: 'Please analyze and rate the current caption' },
    {
      text: 'Design a post graphic',
      message: 'Generate a design that would work well with my caption',
    },
    {
      text: 'Make it more engaging',
      message: 'Make the caption more engaging and add relevant emojis',
    },
  ]

  return (
    <div className="flex h-full flex-col items-center justify-center px-4 py-8 text-center">
      <div className="animate-fade-up animate-duration-500 bg-primary/10 shadow-primary/30 mb-4 flex h-16 w-16 items-center justify-center rounded-full shadow-[0_0_48px_-4px]">
        <CassiSquareIcon width="32" height="32" />
      </div>
      <h3 className="animate-fade-up animate-duration-500 mb-2 text-lg font-semibold">
        Start a conversation
      </h3>
      <p className="animate-fade-up animate-duration-500 text-muted-foreground mb-6 max-w-[280px] text-sm">
        Ask me to write captions, rate your post, design graphics, or schedule for any platform.
      </p>
      <div className="flex flex-col gap-2">
        {suggestions.map((suggestion, i) => (
          <Button
            key={suggestion.text}
            variant="secondary"
            size="sm"
            className="animate-fade-up animate-duration-500"
            style={{ animationDelay: `${i * 75}ms`, animationFillMode: 'backwards' }}
            onClick={() => onSendMessage(suggestion.message)}>
            <MagicIcon color="var(--primary)" />
            <span>{suggestion.text}</span>
          </Button>
        ))}
      </div>
    </div>
  )
}
